import React from 'react';
import "./Pages.css"
const blogs = () => {
    return (
       <div>
          <main className="body">
            <h1 className="header">PROJECTS</h1>
            <h2 className="subheader">CONTENT COMING SOON.</h2>
            </main>
       </div>
    );
}
 
export default blogs;